<template>
    <div>
        <template v-if="pageView == true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Add Call Center Admin</h1>
            </div>
            <div class="global-main">
                <div class="people-management-inner-content">
                    <form id="callCenterForm" @submit.prevent="addCallCenterAdmin">
                        <div class="tab-content-inner">
                            <div class="user-permissions">
                                <div class="form-group">
                                    <label> Name </label>
                                    <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                    <has-error :form="form" field="name"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Mobile No. </label>
                                    <input v-model="form.mobile_no" type="number" name="mobile_no" class="form-control" :class="{ 'is-invalid': form.errors.has('mobile_no') }">
                                    <has-error :form="form" field="mobile_no"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> CNIC </label>
                                    <input v-model="form.cnic" type="number" name="cnic" class="form-control" :class="{ 'is-invalid': form.errors.has('cnic') }">
                                    <has-error :form="form" field="cnic"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> E-Mail Address </label>
                                    <input v-model="form.email" type="email" name="email" class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                                    <has-error :form="form" field="email"></has-error>
                                </div>
                                <div class="form-group btn-holder">
                                    <div class="label-holder"> </div>
                                    <button class="btn btn-default" type="button" v-on:click="generatePassword" style="padding:0 20px;">Generate new password</button>
                                </div>
                                <div class="form-group">
                                    <label> Password </label>
                                    <input v-model="form.password" type="text" name="password" class="form-control" :class="{ 'is-invalid': form.errors.has('password') }">
                                    <has-error :form="form" field="password"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Confirm Password </label>
                                    <input v-model="form.password_confirmation" type="text" name="password_confirmation" class="form-control" :class="{ 'is-invalid': form.errors.has('password_confirmation') }">
                                    <has-error :form="form" field="password_confirmation"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Join Date </label>
                                    <datepicker name="join_date" v-model="form.join_date" input-class="form-control" :class="{ 'is-invalid': form.errors.has('join_date') }"></datepicker>
                                    <has-error :form="form" field="join_date"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> City </label>
                                    <select v-model="form.city_id" name="city_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('city_id') }" v-if="cities != null">
                                        <option value="" selected>Select City</option>
                                        <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
                                            {{ city.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="city_id"></has-error>
                                </div>
                                <div class="page-top mb-1 mb-3 mt-4 clearfix">
                                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                    <router-link to="/callCenterAdminList" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-else-if="pageView === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="pageView === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    mobile_no : '',
                    cnic : '',
                    name : '',
                    email : '',
                    password : '',
                    password_confirmation : '',
                }),
                cities: null,
                pageView: null
            }
        },
        methods: {
            addCallCenterAdmin() {
                this.$Progress.start();
                this.form.post('api/addCallCenterAdmin')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Call center admin created successfully');
                        this.$router.push('/callCenterAdminList');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getaddCallCenterAdminData(){
                this.$Progress.start();
                axios.get('/api/addCallCenterAdminData')
                .then(res => {
                    if(res.status == 200){
                        this.cities = res.data.cities;
                        this.pageView = res.data.pageView;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            generatePassword() {
                var length = 16,
                        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&()_+",
                        retVal = "";
                for (var i = 0, n = charset.length; i < length; ++i) {
                    retVal += charset.charAt(Math.floor(Math.random() * n));
                }
                this.form.password = retVal;
                this.form.password_confirmation = retVal;
                return false;
            }
        },
        mounted() {
            this.getaddCallCenterAdminData();
        }
    }
</script>
